import styled from "styled-components";
import SideBar, { SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from "./SideBar";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, Tooltip } from "@mui/material";

const StyledAppLayout = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.toggle ? SIDEBAR_WIDTH : 0)}px 1fr;
  grid-template-rows: auto 1fr;
  height: 100vh;
  transition: grid-template-columns 0.3s ease-in-out;
`;

const Main = styled.main`
  background-color: #f3f5f7;
  padding: ${TOP_BAR_HEIGHT + 16}px 1rem 2rem;
  overflow: auto;
  min-width: 0;
`;

const IconButtonWrapper = styled.div`
  position: fixed;
  top: 14px;
  left: ${(props) => (props.toggle ? SIDEBAR_WIDTH + 10 : 10)}px;
  z-index: 1300;
  transition: left 0.3s ease-in-out;
`;

export default function AppLayout() {
  // Small screens start with the menu folded away
  const [toggle, setToggle] = useState(() => window.innerWidth >= 900);
  return (
    <StyledAppLayout toggle={toggle}>
      <IconButtonWrapper toggle={toggle}>
        <Tooltip title={toggle ? "Hide menu" : "Show menu"}>
          <IconButton
            size="small"
            aria-label={toggle ? "Hide menu" : "Show menu"}
            onClick={() => setToggle(!toggle)}
            sx={{
              color: "rgba(255,255,255,0.85)",
              borderRadius: "6px",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
            }}
          >
            {toggle ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
        </Tooltip>
      </IconButtonWrapper>
      <Header sidebarOpen={toggle} />
      {toggle ? <SideBar /> : <div style={{ gridRow: "1/-1" }} />}
      <Main>
        <Outlet />
      </Main>
    </StyledAppLayout>
  );
}
